import BarbaJs from './_barba/barba.js';
import ScrollComponent from "./_barba/components/ScrollComponent";
import "./views/menuNav.js"
import Whatsapp from './views/Whatsapp.js';
import {preloadFont} from 'troika-three-text'
import './views/scrollAnimation'
window.initGlobal = function() {
    if (window.navigator.userAgent.match(/MSIE|Trident/) !== null){
        $('body').addClass('is-ie');
    }
    if (window.isTouchDevice === true) {
        $('body').addClass('is-touch').removeClass('is-desktop');
        try { // prevent exception on browsers not supporting DOM styleSheets properly
            for (var si in document.styleSheets) {
                var styleSheet = document.styleSheets[si];
                if (!styleSheet.rules) continue;

                for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
                    if (!styleSheet.rules[ri].selectorText) continue;

                    if (styleSheet.rules[ri].selectorText.match(':hover')) {
                        styleSheet.deleteRule(ri);
                    }
                }
            }
        } catch (ex) {}
    }else{
        $('body').addClass('is-desktop').removeClass('is-touch');
    }
    document.documentElement.style.setProperty('--header-height', `${$('header').outerHeight()}px`);
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    document.documentElement.style.setProperty('--dynamic-vh', `${vh}px`);

    let resizeTimout = false
    $(window).on('resize', () => {
        let dynamicVh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--dynamic-vh', `${dynamicVh}px`);
        document.documentElement.style.setProperty('--header-height', `${$('header').outerHeight()}px`);
        if (resizeTimout){
            window.clearTimeout(resizeTimout)
        }
        
        if (window.scene){
            resizeTimout = window.setTimeout(()=>{
                window.scene.updateScroll(window.globalScroll.y)
                console.log('resize')
                window.clearTimeout(resizeTimout)

            },200)

        }
    }).trigger('resize');
   
    appEvent.listen('app:barba:beforeDone',()=>{
        if (window.scene) window.scene.resetScene()
        $('canvas').removeClass("z-index-fixer")


    });

    appEvent.listen('app:threejsAnimation:start',()=>{
        if (window.scene && window.isTouchDevice != true){
            window.scene.text.addText([...document.querySelectorAll('[data-barba="container"]:last-of-type [data-dynamic-text]')])
        } 
        else{ 
            $('[data-dynamic-text]').css('opacity',1);
        } 
       
        window.scrollAnimation.lazyload()

        window.scrollAnimation.initView()

    });
 
    window.whatsaapPoup.addNotification()
    $('.whatsapp-chat').addClass('show');


};

window.initView = function() {
    window.menuNav.updateCurrentLink();



};

$(window).on('load', function(){
    window.menuNav.init();
    window.whatsaapPoup = new Whatsapp();
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    window.barba = new BarbaJs();
    window.barba.setDefaultTransition();
    window.barba.init();

    window.globalScroll = new ScrollComponent({
        smooth:true,
    });
    if (window.dev == true){
        window.globalScroll.init().then(()=>{
            $('[data-dynamic-text]').css('opacity',1);
            window.landingLoader.init();
            window.scrollAnimation.init()
            window.scrollAnimation.initGlobal()
            window.scrollAnimation.lazyload()
            window.scrollAnimation.initView()

        })
        return false;
    }
    const fontPromise  = new Promise((resolve)=>{

        preloadFont(
            {
              font: base + "/assets/fonts/PlusJakartaSans-Regular.woff", 
              characters: 'abcdefghijklmnopqrstuvwxyz'
            },
            () => {
                resolve(true);
            }
        )
    })
   
    const experiencePromise = new Promise((resolve)=>{
        import(/*webpackMode:"lazy"*/ /*eagger*/ /* webpackChunkName: "experience" */ "./Experience/Experience.js").then((Experience)=>{
            window.scene.autoRender = false

            if (window.isTouchDevice != true && window.scene ){
                window.scene.text.addText([...document.querySelectorAll('[data-dynamic-text]')]);

            }else{
                $('[data-dynamic-text]').css('opacity',1);

            }
            resolve(true); 
  
        })
        
    })
    Promise.all([experiencePromise, fontPromise]).then((values) => {
        window.globalScroll.init().then(()=>{
            window.globalScroll.updateView()
            window.scene.updateScroll(window.globalScroll.y)
            window.scene.resize()
            window.landingLoader.init();
            window.scene.autoRender = false;
            window.scrollAnimation.init()
            window.scrollAnimation.initGlobal()
            window.scrollAnimation.lazyload() 
            window.scrollAnimation.initView()

            
        })
    });
   
});
